import React from 'react';
import { MediumUp, MobileOnly } from 'src/ui/block';
import { ProductFilterComponents } from './product-filter-components';
import { FiltersWrapper } from './styles';
import { RelationsDropdown } from './relations-dropdown';
import { useProductRelationsExperiment } from 'src/hooks/experiments';
import { useAppContext } from 'src/components/app-context';

export const ProductFilters = () => {
  const { market } = useAppContext();
  const isRelationExperimentActive = useProductRelationsExperiment();
  const renderProductFilterComponents = (isMobile: boolean) => {
    return (
      <FiltersWrapper>
        <ProductFilterComponents isMobile={isMobile} />
      </FiltersWrapper>
    );
  };

  return (
    <>
      {isRelationExperimentActive && market.code === 'se' && (
        <RelationsDropdown
          title="Delar i serien"
          relationType="Book series SE/Sweden"
        />
      )}
      <MediumUp>{renderProductFilterComponents(false)}</MediumUp>
      <MobileOnly>{renderProductFilterComponents(true)}</MobileOnly>
    </>
  );
};
